module.exports = __webpack_public_path__ + "static/media/happy-man.612d4b58.png";